export default {
  path: '/lvy-user-agreement-v2',
  component: () => import('./LVYUserAgreementV2'),
  meta: {
    title: '青藤之恋用户协议',
    designWidth: 750,
    expireIn: '',
    axiosConfig: {
      baseURL: '',
      withCredentials: false,
      postContentType: 'JSON'
    }
  }
}